import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c6d8e4a")

_pushScopeId("data-v-5c6d8e4a")
const _hoisted_1 = { "data-testid": "incoming-sti-dest-need-to-sti-dest-del" }
const _hoisted_2 = { class: "flex flex-row justify-between" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "w-1/6 mr-3 whitespace-nowrap" }
const _hoisted_5 = { class: "p-4 pt-0 space-y-4" }
const _hoisted_6 = { class: "w-full pl-2.5 py-2 h-full flex flex-col border-gray-lp-400 overflow-y-auto" }
const _hoisted_7 = { class: "flex border-t h-full border-gray-lp-400 bg-white mt-4" }
const _hoisted_8 = { class: "w-6/12 pl-2 pr-1 mt-2" }
const _hoisted_9 = { class: "w-6/12 pr-2 pl-1 mt-2" }
const _hoisted_10 = { class: "counter" }
const _hoisted_11 = { class: "counter" }
const _hoisted_12 = { class: "overflow-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      title: _ctx.$t('stiDest.needToStiDestDel.title'),
      "vertical-separator": false,
      "full-page": "",
      onBack: _ctx.goBack
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Search, {
              class: "w-64 stt-due-list-search",
              value: _ctx.parameters.search,
              placeholder: _ctx.$t('stiDest.needToStiDestDel.searchPlaceholder'),
              onInput: _ctx.onSearch,
              onClear: _ctx.onSearch
            }, null, 8, ["value", "placeholder", "onInput", "onClear"]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_AdvancedFilter, {
                modelValue: _ctx.parameters,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.parameters = $event)),
                addSumFilter: _ctx.countTotalFilter,
                isDisabled: false,
                onReset: _ctx.onResetAdvancedFilter,
                showResetText: false,
                customPaddingVerticalHeader: 'py-3',
                isScroll: ""
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('stiDest.needToStiDestDel.cargoType')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectCargoType,
                          onCloseSelect: _ctx.onCloseSelectCargoType,
                          isOpenMenu: _ctx.isOpenSelectCargoType,
                          value: _ctx.parameters.cargoType,
                          onChooseSelect: _ctx.onSelectSelectCargoType,
                          dataSelect: _ctx.cargoTypes,
                          class: "w-full whitespace-no-wrap my-2 z-10"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('stiDest.needToStiDestDel.status')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_custom_dropdown, {
                          placeholder: _ctx.$t('stiDest.needToStiDestDel.pilihStatus'),
                          class: "my-2",
                          value: 
                        _ctx.parameters.sttStatus.length
                          ? `${_ctx.parameters.sttStatus.length} Status`
                          : ''
                      
                        }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_6, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttStatuses, (status, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: index,
                                  class: "p-field-checkbox mt-1"
                                }, [
                                  _createVNode(_component_Checkbox, {
                                    name: "status",
                                    id: index,
                                    value: status.value,
                                    modelValue: _ctx.parameters.sttStatus,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.parameters.sttStatus = $event))
                                  }, null, 8, ["id", "value", "modelValue"]),
                                  _createVNode("label", {
                                    for: index,
                                    class: "ml-2.5"
                                  }, _toDisplayString(status.name), 9, ["for"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 8, ["placeholder", "value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode(_component_LpButton, {
                          color: "white",
                          disabled: _ctx.isDisabledApplyFilter,
                          textColor: "red-lp-100",
                          title: _ctx.$t('stiDest.needToStiDestDel.reset'),
                          customClass: "border border-red-lp-100",
                          outline: "",
                          onClick: _ctx.onResetAdvancedFilter,
                          isWidthFull: ""
                        }, null, 8, ["disabled", "title", "onClick"])
                      ]),
                      _createVNode("div", _hoisted_9, [
                        _createVNode(_component_LpButton, {
                          color: "red-lp-100",
                          disabled: _ctx.isDisabledApplyFilter,
                          textColor: "white",
                          title: _ctx.$t('stiDest.needToStiDestDel.terapkan'),
                          onClick: _ctx.onChangeStatus,
                          isWidthFull: ""
                        }, null, 8, ["disabled", "title", "onClick"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "addSumFilter", "onReset"])
            ]),
            _createVNode("button", {
              class: ["ml-4 btn-filter", { 'filter-active': _ctx.parameters.isNow }],
              onClick: _cache[3] || (_cache[3] = 
                () => {
                  // set first page
                  _ctx.controller.setFirstPageSTTDue();
                  _ctx.parameters.isNow = !_ctx.parameters.isNow;
                  _ctx.parameters.isOverdue = false;
                  _ctx.fetchSttDueList();
                }
              )
            }, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("stiDest.needToStiDestDel.saatIni")), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.formatQuantity(_ctx.controller.stiDestSummaryNeedToDel.totalDelNow)), 1)
            ], 2),
            _createVNode("button", {
              class: ["ml-2 btn-filter", { 'filter-active': _ctx.parameters.isOverdue }],
              onClick: _cache[4] || (_cache[4] = 
                () => {
                  // set first page
                  _ctx.controller.setFirstPageSTTDue();
                  _ctx.parameters.isOverdue = !_ctx.parameters.isOverdue;
                  _ctx.parameters.isNow = false;
                  _ctx.fetchSttDueList();
                }
              )
            }, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("stiDest.needToStiDestDel.telat")), 1),
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.formatQuantity(
                    _ctx.controller.stiDestSummaryNeedToDel.totalDelOverdue
                  )), 1)
            ], 2)
          ]),
          _createVNode(_component_LpButton, {
            title: _ctx.$t('stiDest.needToStiDestDel.download'),
            outline: "",
            textColor: "red-lp-100",
            fontWeight: "semibold",
            disabled: !_ctx.controller.listStiDestNeedToDel.data.length,
            onClick: _ctx.downloadExcel
          }, null, 8, ["title", "disabled", "onClick"])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_TableV2, {
            columns: _ctx.columns,
            data: _ctx.controller.listStiDestNeedToDel.data,
            pagination: _ctx.controller.listStiDestNeedToDel.pagination,
            "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => (_ctx.controller.listStiDestNeedToDel.pagination = $event)),
            isRightFreeze: "",
            isShowTryAgainBtn: "",
            isEmpty: 
              !_ctx.controller.listStiDestNeedToDel.data.length &&
                !_ctx.controller.isLoadingListSTIDestNeedToDel &&
                !_ctx.controller.errCauseStiDestNeedToDel
            ,
            isFilter: 
              !!_ctx.parameters.search ||
                !!_ctx.parameters.cargoType ||
                _ctx.parameters.sttStatus.length
            ,
            errorCause: _ctx.controller.errCauseStiDestNeedToDel,
            onTryAgain: _ctx.fetchSttDueList,
            paginationStyle: "v3",
            borderTop: false,
            borderBottom: false,
            loading: _ctx.controller.isLoadingListSTIDestNeedToDel,
            totalColumnFreeze: 1,
            pinnedSubstractHeight: "300px",
            isNoPaddingBottom: "",
            onRequest: _ctx.fetchSttDueList
          }, null, 8, ["columns", "data", "pagination", "isEmpty", "isFilter", "errorCause", "onTryAgain", "loading", "onRequest"])
        ])
      ]),
      _: 1
    }, 8, ["title", "onBack"])
  ]))
})